import RawTokenAmount from './raw-token-amount';

import { StyledSummaryItem, StyledSummaryLabel } from '../send-view.style';

const Amount = ({
  symbol,
  amount,
  decimals,
  title
}: {
  symbol: string;
  amount: string;
  decimals?: number;
  title: string;
}) => {
  return (
    <StyledSummaryItem>
      <StyledSummaryLabel>{title}</StyledSummaryLabel>
      <StyledSummaryLabel>
        <RawTokenAmount symbol={symbol} amount={amount} decimals={decimals} />
      </StyledSummaryLabel>
    </StyledSummaryItem>
  );
};

export default Amount;
